var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVillkorBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 203.358,
    height: 292.377,
    viewBox: "0 0 203.358 292.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 203.358,
    height: 292.377,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M185.411,279.695H7.142A7.142,7.142,0,0,1,0,272.553V30.931A7.141,7.141,0,0,1,7.142,23.79h178.27a7.141,7.141,0,0,1,7.142,7.141V272.553a7.142,7.142,0,0,1-7.142,7.142",
    transform: "translate(0 3.072)",
    fill: "#79719e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M173.056,263.275H16.961a7.142,7.142,0,0,1-7.142-7.142V43.982a7.142,7.142,0,0,1,7.142-7.142h156.1a7.142,7.142,0,0,1,7.142,7.142V256.133a7.142,7.142,0,0,1-7.142,7.142",
    transform: "translate(1.268 4.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M188.082,232.024a34.9,34.9,0,1,1-34.9-34.9,34.9,34.9,0,0,1,34.9,34.9",
    transform: "translate(15.276 25.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M170.921,230.263a19.5,19.5,0,1,1-19.5-19.5A19.5,19.5,0,0,1,170.921,230.263Z",
    transform: "translate(17.037 27.218)",
    fill: "none",
    stroke: "#201547",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M146.532,238.376l-8.385-8.388a1.29,1.29,0,0,1,0-1.826h0l1.825-1.825a1.291,1.291,0,0,1,1.825,0l5.648,5.654,12.1-12.1a1.293,1.293,0,0,1,1.825,0l1.825,1.825a1.293,1.293,0,0,1,0,1.825l-14.838,14.838a1.291,1.291,0,0,1-1.825,0",
    transform: "translate(17.791 28.348)",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M39.079,83.381H147.343a5.646,5.646,0,0,0,0-11.291H39.079a5.646,5.646,0,0,0,0,11.291",
    transform: "translate(4.317 9.31)",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M39.079,113.39H147.343a5.646,5.646,0,0,0,0-11.291H39.079a5.646,5.646,0,0,0,0,11.291",
    transform: "translate(4.317 13.185)",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M39.079,143.4H147.343a5.646,5.646,0,1,0,0-11.291H39.079a5.646,5.646,0,1,0,0,11.291",
    transform: "translate(4.317 17.06)",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M39.079,173.409h78.205a5.646,5.646,0,0,0,0-11.291H39.079a5.646,5.646,0,0,0,0,11.291",
    transform: "translate(4.317 20.936)",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M66.685,219.2H36.948a4.9,4.9,0,0,1-4.885-4.885v-15.4a4.9,4.9,0,0,1,4.885-4.884H66.685a4.9,4.9,0,0,1,4.885,4.884v15.4a4.9,4.9,0,0,1-4.885,4.885",
    transform: "translate(4.141 25.057)",
    fill: "#79719e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M112.342,219.2H82.6a4.9,4.9,0,0,1-4.885-4.885v-15.4a4.9,4.9,0,0,1,4.885-4.884h29.737a4.9,4.9,0,0,1,4.885,4.884v15.4a4.9,4.9,0,0,1-4.885,4.885",
    transform: "translate(10.037 25.057)",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M129.693,44.521H53.587A8.008,8.008,0,0,1,45.6,36.536V24.8a8.008,8.008,0,0,1,7.985-7.985h76.106a8.009,8.009,0,0,1,7.985,7.985v11.74a8.009,8.009,0,0,1-7.985,7.985",
    transform: "translate(5.889 2.171)",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M110.689,21.055c0,11.629-9.768,21.055-21.819,21.055S67.051,32.684,67.051,21.055,76.819,0,88.869,0s21.819,9.426,21.819,21.055",
    transform: "translate(8.659)",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M97.365,17.939A9.862,9.862,0,1,1,87.5,8.077a9.861,9.861,0,0,1,9.862,9.862",
    transform: "translate(10.026 1.043)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVillkorBg);
export default __webpack_public_path__ + "static/media/villkor-bg.ad7cc362adab9b004cab0778a9c9e76b.svg";
export { ForwardRef as ReactComponent };